import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsTalk from "./sections/LetsTalk";
import LocationAndDirections from "./sections/LocationAndDirections";
import Abschluss from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsTalk />
      <LocationAndDirections />
      <Abschluss />
    </div>;
}